import { css } from '@bts-web/utils-style-engine';
import { PageSkeletonWrapper } from '../common';
import { CarouselCardSkeleton } from '../common/components/CarouselCard/CarouselCardSkeleton';
import { PortfolioSummarySkeleton } from './components/sections/PortfolioFloatingSummary/PortfolioSummarySkeleton';
import { PortfolioAreaChartSkeleton } from './components/sections/PortfolioAreaChart/PortfolioAreaChartSkeleton';
import { PortfolioOverviewSkeleton } from './components/sections/PortfolioOverview/PortfolioOverviewSkeleton';

export const PortfolioLoadingSkeleton = () => (
  <PageSkeletonWrapper>
    <PortfolioContentLoadingSkeleton />
  </PageSkeletonWrapper>
);

export const PortfolioContentLoadingSkeleton = () => (
  <>
    <PortfolioSummarySkeleton />

    <PortfolioAreaChartSkeleton />

    <div
      className={css({
        px: 'small',
        py: 'medium',
        display: 'flex',
        flexDirection: 'column',
        gap: 'medium',
      })}
    >
      <CarouselCardSkeleton />

      <PortfolioOverviewSkeleton />
    </div>
  </>
);
